// extracted by mini-css-extract-plugin
export var image = "CardImage-module--image--4dd6a";